export const makeRange = (length: number, startFromZero?: boolean): number[] =>
	Array.from({ length }, (v, idx) => (startFromZero ? idx : idx + 1));

export const makeCustomRange = (start: number, end: number): number[] => {
	const length = end - start + 1;
	return Array.from({ length }, (v, idx) => idx + start);
};
